import { useState } from 'react';
import passicon from '../images/passwordicon.png';
import axios from 'axios';
import loadIcon from '../images/loader2.webp';
const ChangePassword=()=>
{
    const [msg,setMsg]=useState("");
    const [progress,setProgress]=useState(false);
    async function changepass()
    {
        setMsg("");
        let t1=document.getElementById("t3").value.trim();
        let t2=document.getElementById("t4").value.trim();
        if(t1.length<8)
        {
            setMsg("Min Password length is 8!!!");
            return;
        }
        if(t1!=t2)
        {
            setMsg("Both Password must be same!!!");
            return;
        }
        const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });              
        let obj={ulogin:localStorage.getItem("ulogin"),upassword:t1,name:localStorage.getItem("uname"),isvalid:"Y",aadhar:"",panno:"",other:""};
        //console.log(JSON.stringify(obj));        
        //console.log("Token:"+localStorage.getItem("token"));        
        setProgress(true);
        await apiClient.post("/api/User/UpdateUser",obj).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setMsg("Password Updated Successfully");
                document.getElementById("t3").value="";
                document.getElementById("t4").value="";
            }
            else
            {
                setMsg(reply.data.message);
            }
        });
        setProgress(false);
    }
    return(
        
        <>
        <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-10 col-12 p-3">
                <div className="card">
                    <div className="card-header text-center h6 bg-primary text-white">Update Password</div>
                    <div className='card-body p-4'>
                        <center><img src={passicon} style={{width:'100px'}}  /></center>
                           <div className='form-group'>
                                <label>Login</label>
                                <input type="text" id="t1" value={localStorage.getItem("ulogin")} className='form-control' readOnly />
                            </div>
                            <div className='form-group'>
                                <label>Name</label>
                                <input type="text" id="t2" value={localStorage.getItem("uname")} className='form-control' readOnly />
                            </div>
                           <div className='form-group'>
                                <label>New Password (Min 8 Characters)*</label>
                                <input type="password" id="t3" className='form-control' />
                            </div>
                            <div className='form-group'>
                                <label>Re Type Password*</label>
                                <input type="password" id="t4" className='form-control' />
                            </div>
                            <input type="button" onClick={changepass} value="Change Password" className='btn btn-success mt-3' />
                            <br/>
                            <div className='text-danger mt-2'>{msg}</div>                        
                    </div>
                </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-2 col-sm-1 col-12"></div>
        </div>
        {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </>
    );
}
export default ChangePassword;